import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const DuoPelletDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Centrala pe peleți   <span className={styles.highlight}>Duo Pellet</span></p>
      <p className={styles.text}>
        Cazanul pe peleți Duo Pellet N este prevazut pentru încălzirea locuințelor și unităților industriale în modul automat. Peleții sunt transportați cu ajutorul șnecului din buncăr ,care se afla lângă cazan.
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-info" />
          <p>
            Perfecta lui exploatare cu sistem alimentare șnec depinde de corecta lui instalare.
            <p className={styles.text}>
              Folosirea combustibilului potrivit și curățarea sa în timp util.
            </p>
          </p>
        </div>
      </div>
      <p className={styles.text}>
        Combustibilul principal pentru aceasta centrala Duo Pellet se constituie combustibil fracționar ( maxim de 25 mm), peleți din lemn și agro peleți (paie, coji de floarea soarelui, stuf, semințe s.a.).
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-plus" />
          <p className={styles.text}>
            Pentru a trece cazanul la alimentare manuala a combustibilului solid
            <p className={styles.text}>
              - este necesar sa comandați de la producător un grătar din fonta.
            </p>
          </p>
        </div>
      </div>
      <h1 className={styles.title}>Caracteristici</h1>
      <p className={styles.text}>
        Cazanul este dotat cu o carcasa ce îl răcește, făcută din foi de otel cu grosimea de 6 mm. Este rezistent la temperaturi foarte ridicate și este proiectat pentru o funcționare continua.
      </p>
      <p className={styles.text}>
        Pentru a proteja cazanul împotriva pierderilor de căldura, sub carcasa decorativa se afla un strat de material izolant.carcasa însăși este confecționată din tabla de oțel, vopsita cu un strat de vopsea polimerica atât din exterior, cat și din interior.
      </p>
      <p className={styles.text}>
        Cazanul Duo Pellet are un arzător de retorta polonez, care este automatizat și controlat de un controler atașat acestuia. Eficienta cazanului este de un minim de 91%. Este extrem de eficient și sigur.
      </p>
      <p className={styles.text}>
        Construcția acestui arzător este foarte simpla. In partea orizontala a arzătorului avem șnecul de alimentare care leagă buncărul cu peleți și partea capătului de ardere. Capăt care se termina cu un arzător de retorta rotativ. Coroana din fonta este un element mobil al sistemului, care mărunțește eventualele conglomerații de peleți formate. Acest lucru va permite arderea eficienta a combustibilului,deoarece este distribuit uniform în arzător. Motorul -reductor de proveniența germana, al companiei ”NORD”, care garantează o rezistenta ridicata, precum și o funcționare silențioasa, cu lunga durata de viata.  Aerul necesar pentru arderea combustibilului este furnizat direct la retortul din fonta.
      </p>
      <p className={styles.text}>
        Este important sa setam corect pe controler regimul exact de alimentare a combustibilului ,cu pauzele prestabilite, astfel încât sa nu conducă la risipirea combustibilului nears integral, sau relocarea zonei de combustie în șnecul de alimentare. In astfel de cazuri este prevazut un sistem de stingere al incendiilor, în care apa intra în șnecul de alimentare ,astfel stingând focul pătruns.
      </p>
      <p className={styles.text}>
        Camera de ardere foarte mare este amplasată sub schimbătorul de căldura cu patru cai, foarte eficient.
      </p>
      <p className={styles.text}>
        Gazele arse ies în coșul de fum prin gaura de evacuare amplasata în partea superioara din spatele cazanului. Gura de evacuare a gazelor este echipata cu un șubler ce permite în cazul pierderii masive a căldurii prin cos, blocarea parțială a evacuării acesteia.
      </p>
      <h1 className={styles.title}>Alimentarea cu combustibili</h1>
      <p className={styles.text}>
        Dacă nu exista posibilitatea amplasării buncărului și respectiv al mecanismului de alimentare în dreapta cazanului, în partea stânga al cazanului este prevazuta posibilitatea amplasării acestuia pentru lansa mecanismului de alimentare.      </p>
      <p className={styles.text}>
        Astfel, Duo Pellet este adaptat pentru funcționarea acestuia prin reglajul mecanic al tirajului de aer .Aceasta metoda de reglaj pentru un cazan pe peleți este cel mai simplu instrument de automatizare, complet independent fața de alimentarea cu energie electrica.      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fas fa-star " />
          <p className={styles.text}>
            Cazane pe peleți Duo Pellet ocupa un loc fruntaș în gradul de popularitate intre cazanele cu combustibil solid, deoarece arzătorul de retorta instalat pe acest model este foarte rezistent la peleți de calitate inferioara.
          </p>
        </div>
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>17 kW</th>
              <th>25 kW</th>
              <th>31 kW</th>
              <th>38 kW</th>
              <th>50 kW</th>
              <th>62 kW</th>
              <th>75 kW</th>
              <th>95 kW</th>
              <th>120 kW</th>
              <th>150 kW</th>
              <th>200 kW</th>
              <th>250 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>2.5</td>
              <td>2.9</td>
              <td>3.2</td>
              <td>3.9</td>
              <td>4.6</td>
              <td>5.3</td>
              <td>6.2</td>
              <td>7.8</td>
              <td>9.8</td>
              <td>11.3</td>
              <td>15.1</td>
              <td>18.9</td>
            </tr>
            <tr>
              <td>Eficiența, minim</td>
              <td>%</td>
              <td colSpan="12">91</td>
            </tr>
            <tr>
              <td>Volumul buncăr</td>
              <td>dm³</td>
              <td>215</td>
              <td>240</td>
              <td>310</td>
              <td>340</td>
              <td>380</td>
              <td>460</td>
              <td>540</td>
              <td>620</td>
              <td>620</td>
              <td>620</td>
              <td>840</td>
              <td>1050</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>82</td>
              <td>117</td>
              <td>132</td>
              <td>152</td>
              <td>192</td>
              <td>222</td>
              <td>268</td>
              <td>398</td>
              <td>473</td>
              <td>580</td>
              <td>773</td>
              <td>966</td>
            </tr>
            <tr>
              <td>Greutatea cazanului fără apă</td>
              <td>kg</td>
              <td>440</td>
              <td>480</td>
              <td>520</td>
              <td>580</td>
              <td>670</td>
              <td>770</td>
              <td>860</td>
              <td>1170</td>
              <td>1310</td>
              <td>1450</td>
              <td>1790</td>
              <td>2200</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="12">100-180</td>
            </tr>
            <tr>
              <td>Temperatura apei minim recomandată</td>
              <td>°C</td>
              <td colSpan="12">58</td>
            </tr>
            <tr>
              <td>Temperatura maximă a apei</td>
              <td>°C</td>
              <td colSpan="12">90</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei (maxim)</td>
              <td>mPa</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
            </tr>
            <tr>
              <td>Consumul de energie electrică, min</td>
              <td>W</td>
              <td>180</td>
              <td>180</td>
              <td>180</td>
              <td>180</td>
              <td>180</td>
              <td>290</td>
              <td>350</td>
              <td>430</td>
              <td>430</td>
              <td>430</td>
              <td>500</td>
              <td>500</td>
            </tr>
            <tr>
              <td>Diametrul extern racord coș</td>
              <td>mm</td>
              <td>159</td>
              <td>178</td>
              <td>178</td>
              <td>219</td>
              <td>245</td>
              <td>245</td>
              <td>245</td>
              <td>299</td>
              <td>299</td>
              <td>299</td>
              <td>348</td>
              <td>398</td>
            </tr>
            <tr>
              <td>Diametru conexiune rețelei de apă</td>
              <td>mm</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>65</td>
              <td>65</td>
              <td>80</td>
              <td>80</td>
              <td>100</td>
              <td>100</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th>Dimensiuni burlan</th>
              <th>U.M.</th>
              <th>201</th>
              <th>248</th>
              <th>248</th>
              <th>377</th>
              <th>483</th>
              <th>483</th>
              <th>483</th>
              <th>702</th>
              <th>702</th>
              <th>702</th>
              <th>962</th>
              <th>1256</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>201</td>
              <td>248</td>
              <td>248</td>
              <td>377</td>
              <td>483</td>
              <td>483</td>
              <td>483</td>
              <td>702</td>
              <td>702</td>
              <td>702</td>
              <td>962</td>
              <td>1256</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td>mm</td>
              <td>160</td>
              <td>180</td>
              <td>180</td>
              <td>220</td>
              <td>250</td>
              <td>250</td>
              <td>250</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
              <td>350</td>
              <td>400</td>
            </tr>
            <tr>
              <td>Înălțime (minim permisă)</td>
              <td>m</td>
              <td>5</td>
              <td>5</td>
              <td>6</td>
              <td>6</td>
              <td>6</td>
              <td>7</td>
              <td>8</td>
              <td>8</td>
              <td>9</td>
              <td>10</td>
              <td>11</td>
              <td>11</td>
            </tr>
            <tr>
              <td>Capacitatea ventilatorului</td>
              <td>m³/ora</td>
              <td>270</td>
              <td>270</td>
              <td>270</td>
              <td>270</td>
              <td>270</td>
              <td>395</td>
              <td>505</td>
              <td>600</td>
              <td>600</td>
              <td>600</td>
              <td>600</td>
              <td>600</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const DuoPelletDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [1240, 1240, 1240, 1240, 1240, 1640, 1680, 1780, 1950, 1950, 2430, 2430] },
    { param: "B1", unit: "mm", values: [600, 600, 600, 600, 600, 700, 740, 830, 1010, 1010, 1290, 1290] },
    { param: "H", unit: "mm", values: [1450, 1510, 1510, 1540, 1650, 1825, 1925, 2190, 2190, 2190, 2360, 2360] },
    { param: "L", unit: "mm", values: [1040, 1100, 1100, 1170, 1220, 1280, 1325, 1540, 1640, 1780, 1940, 2240] }
  ]

  const headers = ["Parametri", "U.M.", "17 kW", "25 kW", "31 kW", "38 kW", "50 kW", "62 kW", "75 kW", "95 kW", "120 kW", "150 kW", "200 kW", "250 kW"]


  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/DuoPelletSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
